/**
 * Lateralidad Vol3D / MPR: ejes paciente en la caja N³ y rosa L/R/A/P/S/I.
 *
 * Convención de la grilla (tras flipZ del stack):
 *   +X → Left (L), +Y → Posterior (P), +Z → Superior (S)
 * coincidente con LPS y con el axial radiológico (A arriba, R a la izquierda).
 */
import { mpr3dViewBasis } from './mpr3dCamera'

export const PATIENT_AXES = {
  L: { x: 1, y: 0, z: 0, opp: 'R' },
  R: { x: -1, y: 0, z: 0, opp: 'L' },
  P: { x: 0, y: 1, z: 0, opp: 'A' },
  A: { x: 0, y: -1, z: 0, opp: 'P' },
  S: { x: 0, y: 0, z: 1, opp: 'I' },
  I: { x: 0, y: 0, z: -1, opp: 'S' },
}

export function applyFlipZToPatientZ(zIndex, zDim, flipZ) {
  const z = Number(zIndex) || 0
  const n = Math.max(1, Number(zDim) || 1)
  if (!flipZ || n <= 1) return z
  return n - 1 - z
}

/**
 * Etiquetas esperadas en un plano MPR (vista radiológica).
 * Axial: A arriba, P abajo, R izquierda, L derecha.
 */
export function mprPlaneLabels(plane) {
  const p = String(plane || '').toLowerCase()
  if (p === 'sagittal' || p === 'x') {
    return { top: 'S', bottom: 'I', left: 'A', right: 'P' }
  }
  if (p === 'coronal' || p === 'y') {
    return { top: 'S', bottom: 'I', left: 'R', right: 'L' }
  }
  return { top: 'A', bottom: 'P', left: 'R', right: 'L' }
}

function bestLabel(dx, dy, dz) {
  const keys = Object.keys(PATIENT_AXES)
  let best = 'A'
  let score = -1e9
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    const a = PATIENT_AXES[k]
    const s = a.x * dx + a.y * dy + a.z * dz
    if (s > score) {
      score = s
      best = k
    }
  }
  return best
}

/**
 * Rosa de orientación del Vol3D a partir de la base de cámara.
 */
export function vol3dOrientationLabels(yaw, pitch, flipX, flipY) {
  const b = mpr3dViewBasis(yaw, pitch, !!flipX, !!flipY)
  return {
    right: bestLabel(b.rx, b.ry, b.rz),
    left: bestLabel(-b.rx, -b.ry, -b.rz),
    top: bestLabel(b.ux, b.uy, b.uz),
    bottom: bestLabel(-b.ux, -b.uy, -b.uz),
    near: bestLabel(-b.fx, -b.fy, -b.fz),
    far: bestLabel(b.fx, b.fy, b.fz),
  }
}
